export enum USER_SETTING_STEPS_ENUM {
  ORGANISER_DETAILS = 'ORGANISER_DETAILS',
  BANK_DETAILS = 'BANK_DETAILS',
}

export enum CREATE_EVENT_FORM_STEPS_ENUM {
  BASIC_INFO = 'BASIC_INFO',
  DETAILS = 'DETAILS',
  SEATING_PLAN = 'SEATING_PLAN',
  SECTION_LIST = 'SECTION_LIST',
  SEATING_DISABLE = 'SEATING_DISABLE',
  TICKETS = 'TICKETS',
  TAXES = 'TAXES',
  PERMISSIONS = 'PERMISSIONS',
  PROMOTE = 'PROMOTE',
  PUBLISH = 'PUBLISH',
}

export enum SHOW_NAVMENU_STEPS_ENUM {
  BASIC_INFO = 'BASIC_INFO',
  DETAILS = 'DETAILS',
  TICKETS = 'TICKETS',
  TAXES = 'TAXES',
  PROMOTE = 'PROMOTE',
  PUBLISH = 'PUBLISH',
}

export enum SHOW_NAVMENU_PUBLISHED_STEPS_ENUM {
  BASIC_INFO = 'BASIC_INFO',
  DETAILS = 'DETAILS',
  TICKETS = 'TICKETS',
  TAXES = 'TAXES',
  PROMOTE = 'PROMOTE',
}

export const eventMenuSubarrayMap = {
  BASIC_INFO: ['Basic Info', 'LOCATION', 'DATE'],
  DETAILS: ['Details', 'EVENT IMAGE', 'DESCRIPTION', 'TERMS & CONDITIONS'],
  TICKETS: ['Tickets'],
  TAXES: ['Taxes', 'CONTACTS'],
  PROMOTE: ['Promote', 'VIDEO', 'SOCIAL MEDIA'],
  PUBLISH: ['Publish'],
};

export type PaymentGatewayType = {
  settingType: string;
  value: string;
  gatewayType: string;
};
